export class InvoiceAmountCalc {
  public expensesSumTaxExcluded : string | null;
  public expensesSumVAT : string | null;
  public expensesSumTaxIncluded : string | null;

  public amendmentsSumTaxExcluded : string | null;
  public amendmentsSumVAT : string | null;
  public amendmentsSumTaxIncluded : string | null;

  public invoiceSumMarketWithAmendment: string | null;

  public deductionsSumProvisionedTaxExcluded : string | null;
  public deductionsSumProvisionedTaxExcludedWithSign : string | null;
  public deductionsSumReleasedTaxExcluded : string | null;
  public deductionsSumRetainedTaxExcluded : string | null;

  public marketAndAmendmentsVAT : string | null;
  public marketAndAmendmentsTaxIncluded : string | null;
}